export function getUserAgent() {
  return navigator.userAgent || "none";
}
